import React, { ReactNode } from 'react';

import classNames from 'classnames';

import classes from './GridTableCell.module.scss';

type GridTableCellProps = {
  children?: ReactNode;
  className?: string;
  justify?: 'center' | 'end' | 'start' | 'stretch' | 'auto';
  align?: 'top' | 'center' | 'bottom' | 'auto';
  variant?: 'title' | 'cell';
  dataTestId?: string;
};

const GridTableCell = ({
  children,
  className,
  justify,
  align,
  variant = 'cell',
  dataTestId,
}: GridTableCellProps) => {
  const cellClasses = classNames(
    justify && classes[`justify-${justify}`],
    align && classes[`align-${align}`],
    classes[variant],
    className,
  );

  return (
    <div className={cellClasses} data-test-id={dataTestId}>
      {children}
    </div>
  );
};

export { GridTableCell };
